import create from 'zustand'
import config from './_config'
import store from '../../store'
import { Hotlinks } from './types'
import { State } from '../../store/types'
import { API } from '../../internal/types'
import { useInfiniteQuery } from '../../internal'

const useListHotlinks = (
  defaultFilters?: Hotlinks.ListFilters,
  options?: API.QueryOptions
) => {
  const useStore = create<State>(store)

  const { networkId } = useStore()

  const query = useInfiniteQuery<Hotlinks.ListFilters>(defaultFilters, options)

  const response = query<Hotlinks.Hotlink[]>({
    cacheKey: config.cacheKeys.list(),
    endpoint: config.endpoint(networkId)
  })

  return response
}

export default useListHotlinks
